import { useEffect, useState } from 'react';
import { de } from '@/i18n/de';
import { Skeleton } from '@/shell/ui/skeleton';
import { VisuallyHidden } from '@/shell/ui/visually-hidden';

const DEFAULT_SLOW_MS = 10_000;

type LoadingBlockProps = {
  /** Höhe des Blocks in Pixeln: der Platzhalter ist so hoch wie der spätere Inhalt (kein Springen). */
  height: number;
  /** Nach dieser Zeit erscheint „Dauert länger als üblich.“ (Standard 10 s, „Heute“ 8 s). */
  slowAfterMs?: number;
};

/** Skelett in Blockgröße ohne Animation; sagt „Wird geladen“ an und meldet nach der Schwelle, wenn es dauert. */
export function LoadingBlock({ height, slowAfterMs = DEFAULT_SLOW_MS }: LoadingBlockProps) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setSlow(true), slowAfterMs);
    return () => clearTimeout(timer);
  }, [slowAfterMs]);

  return (
    <div role="status" className="relative" style={{ minHeight: `${height}px` }}>
      <VisuallyHidden>{de.states.loading}</VisuallyHidden>
      <Skeleton height={height} />
      {slow ? (
        <p className="absolute inset-0 flex items-center justify-center px-4 text-center text-body text-ink-muted">
          {de.states.slow}
        </p>
      ) : null}
    </div>
  );
}
